import React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import blogIconSmall from '@icons/blogIconSmall';
import playbooksIconSmall from '@icons/playbooksIconSmall';
import guidesIconSmall from '@icons/guidesIconSmall';
import caseStudiesIconSmall from '@icons/caseStudiesIconSmall';
import streamIconSmall from '@icons/streamIconSmall';
import newslettersIconSmall from '@icons/newslettersIconSmall';
import salesStoicIconSmall from '@icons/sales-stoic-icon.png';
import tamCalcIconSmall from '@icons/tamCalcIconSmall';
import academyIconSmall from '@icons/academyIconSmall';
import partnersIconSmall from '@icons/partnersIconSmall';
import contactUsIconSmall from '@icons/contactUsIconSmall';
import helpCenterIconSmall from '@icons/helpCenterIconSmall';
import productUpdatesIconSmall from '@icons/productUpdatesIconSmall';
import IconLink from '@components/IconLink';

import LatestResourcesCTA from '../../ctas/LatestResources';

export const Resources = () => {
  const { t } = useTranslation();
  const { language } = useI18next();

  return {
    label: t('nav_label_resources'),
    submenus: [
      {
        label: t('nav_label_content'),
        columns: 2,
        subgroups: [
          {
            label: t('nav_label_blog'),
            href: '/blog',
            caption: t('nav_label_blog_caption'),
            icon: blogIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_guides'),
            href: '/guides',
            caption: t('nav_label_guides_caption'),
            icon: guidesIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_playbooks'),
            href: '/resources/playbooks',
            caption: t('nav_label_playbooks_caption'),
            icon: playbooksIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_customers_page'),
            href: '/customers',
            caption: t('nav_label_customers_caption'),
            icon: caseStudiesIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_stream'),
            href: '/resources/stream',
            caption: t('nav_label_stream_caption'),
            icon: streamIconSmall,
            grid: true,
            lang: 'en',
          },
          {
            label: t('nav_label_newsletters'),
            href: '/resources/newsletters',
            caption: t('nav_label_newsletters_caption'),
            icon: newslettersIconSmall,
            grid: true,
          },
          // {
          //   label: t('nav_label_sales_stoic_page'),
          //   href: '/resources/the-sales-stoic',
          //   caption: t('nav_label_sales_stoic_caption'),
          //   icon: salesStoicIconSmall,
          //   grid: true,
          // },
          // {
          //   label: '',
          //   href: '/',
          //   caption: '',
          //   grid: true,
          //   spacer: true,
          // },
          {
            label: '',
            iconLink: (
              <IconLink
                theme="dark"
                href="/resources/all"
                classes={'view-all-resources'}
              >
                {t('view_all_resources')}
              </IconLink>
            ),
          },
          /*{
            label: t('nav_label_reports'),
            href: '/resources/reports',
            caption: t('nav_label_reports_caption'),
            grid: true,
          },*/
        ],
      },
      {
        label: t('nav_label_community'),
        subgroups: [
          {
            label: t('nav_label_product_updates'),
            href: '/platform/product-updates',
            caption: t('nav_label_product_updates_caption'),
            icon: productUpdatesIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_partners'),
            href: '/partners',
            caption: t('nav_label_partners_caption'),
            icon: partnersIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_tam'),
            href:
              language === 'de'
                ? 'https://www.dealfront.com/tools/tam-calculator/de/'
                : 'https://www.dealfront.com/tools/tam-calculator/',
            caption: t('nav_label_tam_caption'),
            icon: tamCalcIconSmall,
            grid: true,
          },
        ],
      },
      {
        label: t('nav_label_support'),
        subgroups: [
          {
            label: t('nav_label_academy'),
            href: '/resources/academy',
            lang: 'en',
            caption: t('nav_label_academy_label'),
            icon: academyIconSmall,
            grid: true,
          },
          {
            label: 'Help Center',
            href:
              language === 'de'
                ? 'https://help.dealfront.com/de/'
                : 'https://help.dealfront.com/en/',
            lang: 'en',
            caption: t('nav_label_help_centre_label'),
            icon: helpCenterIconSmall,
            grid: true,
          },
          {
            label: t('nav_label_contact'),
            href: '/contact',
            caption: t('nav_label_contact_label'),
            icon: contactUsIconSmall,
            grid: true,
          },
        ],
      },
    ],
    ctas: [
      { label: t('nav_latest_resources'), content: <LatestResourcesCTA /> },
    ],
  };
};
